var React = require('react');

function Diagonal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 944H1.5L273 0H0V944Z","fill":"#4E5D70"}));
}

Diagonal.defaultProps = {"width":"273","height":"944","viewBox":"0 0 273 944","fill":"none"};

module.exports = Diagonal;

Diagonal.default = Diagonal;
